const initializeMenuDrawer = () => {
  const menuDrawerEl = document.querySelector("#fs-menu-drawer");
  if (!menuDrawerEl) {
    return;
  }
  addEvents(menuDrawerEl);
};

const addEvents = (menuDrawerEl) => {
  menuDrawerEl.addEventListener("show", () => {
    show(menuDrawerEl);
  });
  menuDrawerEl.addEventListener("hide", () => {
    hide(menuDrawerEl);
  });

  const backdrop = menuDrawerEl.querySelector(".fs-backdrop");
  backdrop.addEventListener("click", () => {
    hide(menuDrawerEl);
  });

  menuDrawerEl.querySelector(".fs-close-button").addEventListener("click", () => {
    hide(menuDrawerEl);
  });
};

const show = (menuDrawerEl) => {
  const backdrop = menuDrawerEl.querySelector(".fs-backdrop");
  const container = menuDrawerEl.querySelector(".fs-container");

  container.style.display = "block";
  backdrop.classList.add("show");
  setTimeout(() => {
    container.classList.add("show");
  }, 100);
};

const hide = (menuDrawerEl) => {
  const backdrop = menuDrawerEl.querySelector(".fs-backdrop");
  const container = menuDrawerEl.querySelector(".fs-container");

  backdrop.classList.remove("show");
  container.classList.remove("show");
  setTimeout(() => {
    container.style.display = "none";
  }, 500);
};

/*
 * Main
 */

const menuDrawerMain = () => {
  initializeMenuDrawer();
};

addEventListener("DOMContentLoaded", (event) => {
  menuDrawerMain();
});
